import React, { useState } from 'react';
import Sidebar from 'react-sidebar';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { MenuOutlined } from '@ant-design/icons';
import { SECONDARY, LIGHT } from '../constants/Colors';

const Container = styled.div`
    

`
const MenuButton = styled(MenuOutlined)`
    display: none;
    @media (max-width: 768px) {
        display: flex;
        font-size: 18px;
        color: black;
        left: 20px;
        top: 22px;
        position: fixed;
    }
`

const MenuContainer = styled.div`
    padding-top: 20px;

`
const Item = styled(NavLink)`
    display: flex;
    align-items: center;
    color: #212b36;
    font-size: 14px;
    margin-bottom: 10px;
    padding: 10px 10px 10px 20px;
    :hover {
        color: #212b36;
    }
`
const Menu = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 20px;
`

const Icon = styled.img`
    width: 20px;
    height: 20px;
    margin-right: 10px;
`


export default ({ menuItems = [] }) => {
    const isMobile = window.matchMedia("(max-width: 768px)").matches;
    const [open, setSidebarOpen] = useState(false);
    return (
        <Container>
            {isMobile ?
                <MenuButton
                    onClick={() => setSidebarOpen(true)}
                />
                : null
            }
            <Sidebar
                sidebar={
                    <MenuContainer>
                        <Menu>
                            {menuItems.map(item =>
                                <Item
                                    key={item.path}
                                    to={item.path}
                                    activeStyle={{
                                        color: SECONDARY,
                                        fontWeight: 'bold',
                                        background: LIGHT
                                    }}
                                >
                                    {window.location.pathname === item.path ?
                                    <Icon src={require(`../images${item.path}-filled.png`)} />
                                    :
                                    <Icon src={require(`../images${item.path}.png`)}/>
                }
                                    {item.name}
                                </Item>
                            )}
                        </Menu>
                    </MenuContainer>

                }
                docked={isMobile ? false : true}
                open={open}
                onSetOpen={() => setSidebarOpen(false)}
                styles={{
                    sidebar: {
                        background: "white",
                        width: 250,
                        borderRight: '1px solid #DFE3E7'
                    },
                    root: {
                        width: isMobile && !open ? 0 : 250,
                        height: '100vh',
                        top: 60
                    }
                }}
            />
        </Container>
    )
}